import script from "./IndicatorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicatorForm.vue?vue&type=script&setup=true&lang=js"

import "./IndicatorForm.vue?vue&type=style&index=0&id=1cb9c995&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb9c995"]])

export default __exports__